"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PaperAirplaneSolid: function() {
        return PaperAirplaneSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PaperAirplaneSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M22.9285 2.37142C23.077 2 22.99 1.57578 22.7071 1.29292C22.4242 1.01006 22 0.922986 21.6286 1.07155L1.62861 9.07155C1.23898 9.2274 0.988108 9.60994 1.00043 10.0294C1.01276 10.4489 1.28567 10.816 1.68378 10.9487L9.14875 13.437L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L10.563 14.8512L13.0513 22.3163C13.184 22.7144 13.5512 22.9873 13.9706 22.9996C14.3901 23.0119 14.7726 22.761 14.9285 22.3714L22.9285 2.37142Z",
        fill: "currentColor"
    })
}), "PaperAirplaneSolid");
const _default = PaperAirplaneSolid;
